// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__bEbrZ","load2":"Spinner_load2__3sdmd"};